import React from 'react'
import Cart from '../Cart';
import TabGenerator from './TabGenerator';
import './index.scss';
import { Container } from '@material-ui/core';

export default (props) => {
    return (
        <React.Fragment>

            <Container component="nav" className="navWrapper">
                <TabGenerator onCollapse={props.onCollapse} />
                {props.configuration.head.topbarConfiguration && props.configuration.head.topbarConfiguration.cartOnTabs &&
                    <Cart isOnTab={true} cart={props.cart} onTrigger={props.onTrigger} configuration={props.configuration}/>
                }
                
            </Container>
        </React.Fragment>
    );
}
